<script lang="ts">
    import { createEventDispatcher } from "svelte";

    export let type = "text";
    export let value = "";
    export let id = "";
    export let placeholder = "";
    export let validator = (value) => null;
    export let debounce = false;
    export let debounceTime = 750;
    export let maxLength
    export let autocomplete = true;

    let error, timer;

    const dispatch = createEventDispatcher();

    const handleInput = (e) => {
        if (maxLength && e.target.value.length > maxLength)
            e.target.value = e.target.value.slice(0, maxLength);
        const v = type.match(/^(number|range)$/) ? +e.target.value : e.target.value;
        if (debounce) {
            doDebounce(v);
        } else {
            value = v;
            dispatch("input", v);
        }
    };

    const doDebounce = (v) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            value = v;
            dispatch("input", v);
        }, debounceTime);
    };

    export const validate = () => {
        const validation = validator(value);
        if (validator(value)?.error) {
            ({ error } = validation);
            return {
                ok: false,
            };
        } else {
            error = null;
            return {
                ok: true,
                value,
            };
        }
    };
</script>

<div class="flex w-full flex-col gap-y-2">
    {#if $$slots.label}
        <div class="font-light text-gray-100">
            <slot name="label" />
        </div>
    {/if}
    {#if $$slots.description}
    <span class="text-gray-400">
      <slot name="description" />
    </span>
    {/if}
    <input
            {id}
            {type}
            {value}
            {placeholder}
            autocomplete={autocomplete ? "on" : "off"}
            on:input={handleInput}
            on:blur={validate}
            class="form-control"
    />
    {#if error}
        <span class="text-red-400">{error}</span>
    {/if}
</div>
